export const errorMap: object = {
    default: 'An unknown error occurred. Please try again.',
    changePassword: {
        code: {
            InvalidParameterException: {
                messageContains: {
                    previousPassword: 'Incorrect password.',
                    proposedPassword: 'Invalid new password. Must contain at least 8 characters with a lowercase letter and a number.'
                }
            },
            NotAuthorizedException: 'Incorrect password.'
        }
    },
    resetPassword: {
        code: {
            InvalidParameterException: {
                messageContains: {
                    password: 'Invalid new password. Must contain at least 8 characters with a lowercase letter and a number.'
                }
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/providers/aws/errorMap.ts